import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

interface IRectangle {
  className?: string;
  children: any;
}

export const StyledRectangle = styled.div`
  display: flex;
  padding: ${rem(`72px`)} ${rem(`85px`)};
  border-radius: ${rem(`16px`)};
  position: relative;
  box-sizing: border-box;
  background-clip: padding-box;
  border: solid 1px transparent;
  background: ${({ theme }) => `linear-gradient(
      135deg,
      ${theme.colors.blue_1},
      ${theme.colors.blue_1_90}
    )`};
  ::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    margin: -2px;
    z-index: -1;
    background: ${({ theme }) => `linear-gradient(
          -170deg,
          ${theme.colors.blue_1_30},
          ${theme.colors.blue_1_65},
          ${theme.colors.pink_2}
        )`};
  }
  &.rectangle--pad-36 {
    padding: ${rem(`36px`)};
  }
  &.rectangle--no-bg {
    background: ${({ theme }) => theme.colors.blue_1};
  }
`;

export const Rectangle = ({ className, children }: IRectangle) => (
  <StyledRectangle className={className}>{children}</StyledRectangle>
);
